import React from 'react';
import { useAuthStore } from '../../store/authStore';

export const UserDebug: React.FC = () => {
  const { user, isAuthenticated } = useAuthStore();

  return (
    <div className="fixed bottom-4 right-4 bg-black bg-opacity-80 text-white p-4 rounded-lg max-w-sm">
      <h3 className="font-bold text-sm mb-2">Debug Info</h3>
      <div className="text-xs space-y-1">
        <div>Authenticated: {isAuthenticated ? 'Yes' : 'No'}</div>
        {user && (
          <>
            <div>User ID: {user.userId}</div>
            <div>Email: {user.email}</div>
            <div>Name: {user.name}</div>
            <div className="font-bold">User Type: {user.userType}</div>
            <div>Created: {user.createdAt}</div>
          </>
        )}
      </div>
    </div>
  );
};
